import { defineMessages, type MessageDescriptor } from 'react-intl';
import type { EventType } from '../../contracts/routines.types';

export const ROUTINE_EVENT_TYPE_LABELS = defineMessages({
  note_generated: {
    defaultMessage: 'When a note is generated',
    id: '7h/0FLKPdb',
    description: 'Event trigger option: routine runs when a note is generated',
  },
  session_created: {
    defaultMessage: 'When a session is created',
    id: 'DwYq1e3l90',
    description: 'Event trigger option: routine runs when a session is created',
  },
  session_transcribing: {
    defaultMessage: 'While the session is transcribing',
    id: 'xDROMSSXia',
    description: 'Event trigger option: routine runs while the session is transcribing',
  },
  session_transcribing_stopped: {
    defaultMessage: 'When transcribing stops',
    id: 'sOzPhe7vSl',
    description: 'Event trigger option: routine runs when transcribing stops',
  },
  document_created: {
    defaultMessage: 'When a document is created',
    id: 'IhXRMqQbs4',
    description: 'Event trigger option: routine runs when a document is created',
  },
  document_generated: {
    defaultMessage: 'When a document is generated',
    id: 'BQkaY6OEQS',
    description: 'Event trigger option: routine runs when a document is generated',
  },
  patient_created: {
    defaultMessage: 'When a patient is created',
    id: 'VNYHDkXd01',
    description: 'Event trigger option: routine runs when a patient is created',
  },
  patient_linked: {
    defaultMessage: 'When a patient is linked',
    id: 'Ahy5KQKn/9',
    description: 'Event trigger option: routine runs when a patient is linked',
  },
  remote_recording_transcribed: {
    defaultMessage: 'When a Heidi Remote recording is transcribed',
    id: 'vxMrYC4p64',
    description:
      'Event trigger option: routine runs once a Heidi Remote upload has been transcribed',
  },
  uploaded_audio_transcribed: {
    defaultMessage: 'When uploaded audio is transcribed',
    id: 'hVwVc4HiFx',
    description:
      'Event trigger option: routine runs once audio uploaded in the app has been transcribed',
  },
  task_created: {
    defaultMessage: 'When a task is created',
    id: '4yZANU21Ie',
    description: 'Event trigger option: routine runs when a task is created',
  },
  session_status_changed: {
    defaultMessage: 'When a session status changes',
    id: 'vIE/FBI6BG',
    description:
      'Event trigger option: routine runs when a session review status changes, e.g. to Approved or Sent',
  },
}) satisfies Record<EventType, MessageDescriptor>;
